import { render, staticRenderFns } from "./bigdatamonitoring.vue?vue&type=template&id=1aef3cf0&scoped=true&"
import script from "./bigdatamonitoring.vue?vue&type=script&lang=js&"
export * from "./bigdatamonitoring.vue?vue&type=script&lang=js&"
import style0 from "./bigdatamonitoring.vue?vue&type=style&index=0&id=1aef3cf0&prod&lange=scss&scoped=true&lang=css&"
import style1 from "./bigdatamonitoring.vue?vue&type=style&index=1&id=1aef3cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef3cf0",
  null
  
)

export default component.exports